import { useState } from "react";
import type { ArchiveFaq } from "@/types/archive";

export default function FaqList({ items }: { items: ArchiveFaq[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-200 border-y border-background-200">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : index)}
                aria-expanded={isOpen}
                className="w-full flex items-start justify-between gap-4 py-5 text-left cursor-pointer"
              >
                <span className="font-heading text-base md:text-lg font-semibold text-foreground-900">
                  {item.q}
                </span>
                <span
                  className={`shrink-0 w-7 h-7 flex items-center justify-center rounded-full border border-background-300 text-foreground-600 transition-transform duration-300 ${
                    isOpen ? "rotate-45" : ""
                  }`}
                >
                  <i className="ri-add-line text-lg" aria-hidden="true"></i>
                </span>
              </button>
            </h3>
            <div
              className={`overflow-hidden transition-all duration-300 ${
                isOpen ? "max-h-96 opacity-100 pb-6" : "max-h-0 opacity-0"
              }`}
            >
              <p className="text-sm leading-relaxed text-foreground-500 pr-10">{item.a}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}